import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoryHiringList from './category_hiring_list';
import CategoryHiringDetail from './category_hiring_detail';

class CategoryHiring extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CategoryHiringList/>;
    }else{
      if(params.id===undefined){
        view = <CategoryHiringDetail/>;
      }else{
        view = <CategoryHiringDetail action={params.action}/>;
      }
    }
    return (
      <div className="category-page">{view}</div>
    );
  }
}

CategoryHiring.contextTypes = {
  router: PropTypes.object
};

export default CategoryHiring;
